import * as React from 'react';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { GeoMap, ItemCardList } from 'components';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'redux';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import {
	searchOffices,
	setDateFilter,
	setLocationFilter,
	setLocationFilteringStatus,
	setPreviousLocation,
	setShopTypeFilter,
} from 'redux/modules/shop/offices';
import {
	addURLSearchParams,
	createDomainValueOptions,
	deleteURLSearchParams,
	detectIncompatibleBrowsers,
	getNextPageCount,
	readURLSearchParams,
} from 'helpers/common';
import { IItemCardList } from 'models/itemcard';
import { IOfficeListItem, IOfficeListItemExtended, IOfficesData, ISearchGeoCoordinates } from 'models/shop/office';
import { getCountryCallingCodeDomainValues, getShopTypeDomainValues } from 'redux/modules/domainvalues';
import renderIcon, { IconName } from 'helpers/renderIcon';
import { Button, EllipseGreyBlackButton } from 'components/Common/Button';
import { AnyMapItem } from 'models/map';
import { haversine_distance } from 'helpers/maps';
import { closeModal, showModal } from 'redux/modules/modal';
import SearchFilter from './FilterFields/SearchFilter';
import LocationFilter from './FilterFields/LocationFilter';
import DateFilter from './FilterFields/DateFilter';
import { browserHistory } from 'react-router';

type ReduxInjectedProps = Partial<ReturnType<typeof stateToProps> & ReturnType<typeof dispatchToProps>>;

interface IProps extends ReduxInjectedProps {
	t?: (key: string) => string;
}

interface IState {
	geoLocation?: ISearchGeoCoordinates;
	hoverOver?: IOfficeListItem['id'];
	clicked?: IOfficeListItem['id'];
	search: string;
	customBounds: boolean;
	categoriesNotScrolled: boolean;
	categoriesScrolledToTheEnd: boolean;
	locationFilter: 0 | 1;
	dateFilter: 0 | 1;
	timeFilter: 0 | 1;
	sortFilter: 0 | 1;

	previousLatitude?: number;
	previousLongitude?: number;
}

const stateToProps = (state: IStore) => ({
	officesData: state.offices,
	userPreferences: state.userPreferences,
	shopTypeDomainValues: state.domainValues.shopType,
	geoLatitude: state.offices?.geoCoordinates?.latitude,
	geoLongitude: state.offices?.geoCoordinates?.longitude,
	previousLatitude: state.offices?.previousGeoCoordinates?.latitude,
	previousLongitude: state.offices?.previousGeoCoordinates?.longitude,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	setLocation: (location: ISearchGeoCoordinates) => dispatch(setLocationFilter(location)),
	setLocationFilteringStatus: (status: boolean) => dispatch(setLocationFilteringStatus(status)),
	setPreviousLocation: (latitude: number, longitude: number) => dispatch(setPreviousLocation(latitude, longitude)),
	setShopTypeFilter: (shopTypes: number[]) => dispatch(setShopTypeFilter(shopTypes)),
	setDateFilter: (dateFilter: number) => dispatch(setDateFilter(dateFilter)),
	searchOffices: (isFirstLoad: boolean, isRefinement: boolean) => dispatch(searchOffices(isFirstLoad, isRefinement)),
	getShopTypeDomainValues: () => dispatch(getShopTypeDomainValues()),
	getCountryCallingCodeDomainValues: () => dispatch(getCountryCallingCodeDomainValues()),
	showModal: (type: string, modalProps: any) => dispatch(showModal(type, modalProps)),
	closeModal: () => dispatch(closeModal()),
	dispatch,
});

const defaultDistance = c.SALONS_DEFAULT_MAX_DISTANCE;

const getTilesById = (id: string) => document.querySelectorAll('.officeItem-' + id);
const getTilesByIdDesktop = (id: string) => document.querySelectorAll('.itemsHolder .officeItem-' + id);
const getTilesByIdMobile = (id: string) => document.querySelectorAll('.mapHolder .officeItem-' + id);

const locationCache: { [key: string]: any } = {};
const cacheObject = <T extends object>(l: T): T => {
	const key = JSON.stringify(l);
	if (!(key in locationCache)) {
		locationCache[key] = l;
	}
	return locationCache[key];
};

let scrollTimeout;

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SalonsPage extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.setHovered = this.setHovered.bind(this);
		this.unsetHovered = this.unsetHovered.bind(this);
		this.submitSearch = this.submitSearch.bind(this);
		this.openFiltersModal = this.openFiltersModal.bind(this);
		this.changeDistance = this.changeDistance.bind(this);
		this.resetDistance = this.resetDistance.bind(this);
		this.resetSearch = this.resetSearch.bind(this);
		this.searchArea = this.searchArea.bind(this);
		this.setBounds = this.setBounds.bind(this);
		this.resetBounds = this.resetBounds.bind(this);
		this.markerClick = this.markerClick.bind(this);
		this.scrollMobile = this.scrollMobile.bind(this);
		this.handleCategoriesScroll = this.handleCategoriesScroll.bind(this);
		this.handleResetAllFilters = this.handleResetAllFilters.bind(this);

		this.state = {
			search: '',
			customBounds: false,
			categoriesNotScrolled: true,
			categoriesScrolledToTheEnd: false,
			locationFilter: readURLSearchParams(c.SHOPS_LOCATION_FILTER) ? 1 : 0,
			dateFilter: readURLSearchParams(c.SHOPS_DATE_FILTER) ? 1 : 0,
			timeFilter:
				readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Min') || readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Max') ? 1 : 0,
			sortFilter: readURLSearchParams(c.SHOPS_SORT_FILTER) ? 1 : 0,
			clicked: '',
		};
	}
	history = browserHistory;
	categoriesContainerRef = React.createRef<HTMLDivElement>();
	// To prevent auto scroll scrolling too much
	salonsItemsListRef = React.createRef<HTMLDivElement>();

	private bounds?: google.maps.LatLngBounds;

	public componentDidMount(): void {
		/////////////////////////////////////////////
		// Detect scrolling in categories bar
		/////////////////////////////////////////////
		this.categoriesContainerRef.current.addEventListener('scroll', this.handleCategoriesScroll);
		this.props.getShopTypeDomainValues();
		this.props.getCountryCallingCodeDomainValues();
		const { geoCoordinates } = this.props.officesData;

		setTimeout(() => {
			if (detectIncompatibleBrowsers()) {
				document.body.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			} else {
				window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			}
		}, 100);

		if (geoCoordinates) {
			return;
		}
		if (!navigator || !('geolocation' in navigator)) {
			/* geolocation IS NOT available */
			return this.setGeoLocation();
		}
		let geoLocationSet = false;
		setTimeout(() => {
			if (!geoLocationSet) {
				geoLocationSet = true;
				this.setGeoLocation();
			}
		}, 3000);
		navigator.geolocation.getCurrentPosition(
			(position) => {
				geoLocationSet = true;
				const latUrl = readURLSearchParams(c.SHOPS_LOCATION_FILTER_LAT);
				const lngUrl = readURLSearchParams(c.SHOPS_LOCATION_FILTER_LNG);
				this.setGeoLocation({
					latitude: latUrl ? Number(latUrl) : position.coords.latitude,
					longitude: lngUrl ? Number(lngUrl) : position.coords.longitude,
					distance: defaultDistance,
					precise: true,
				});
			},
			() => {
				geoLocationSet = true;
				this.setGeoLocation();
			},
			{
				timeout: 10000,
			},
		);
		// this.scrollMobile();

		// get categories from url
		const categories = readURLSearchParams(c.SHOPS_CATEGORIES_FILTER);
		if (categories) {
			this.props.setShopTypeFilter(categories.split(',').map((e) => +e));
		}
	}

	public componentDidUpdate(prevProps: Readonly<IProps>): void {
		if ((prevProps.officesData?.items?.length || 0) !== this.props.officesData?.items?.length) {
			this.scrollMobile();
		}
		if (prevProps.officesData?.isFilteringLocation !== this.props.officesData?.isFilteringLocation) {
			this.setState({ locationFilter: this.props.officesData.isFilteringLocation ? 1 : 0 });
		}
		if (prevProps.officesData?.dateFilter !== this.props.officesData?.dateFilter) {
			this.setState({ dateFilter: this.props.officesData.dateFilter ? 1 : 0 });
		}
		if (prevProps.officesData?.timeFilter !== this.props.officesData?.timeFilter) {
			this.setState({
				timeFilter: this.props.officesData.timeFilter?.closeTime || this.props.officesData.timeFilter?.openTime ? 1 : 0,
			});
		}
		if (prevProps.officesData?.sortFilter !== this.props.officesData?.sortFilter) {
			this.setState({
				sortFilter: Boolean(this.props.officesData.sortFilter) || this.props.officesData.sortFilter === 0 ? 1 : 0,
			});
		}
	}

	public componentWillUnmount(): void {
		this.categoriesContainerRef.current.removeEventListener('scroll', this.handleCategoriesScroll);
	}

	private handleCategoriesScroll() {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			const categoriesContainer = this.categoriesContainerRef.current;
			if (categoriesContainer) {
				this.setState({
					categoriesNotScrolled: categoriesContainer.scrollLeft === 0,
					categoriesScrolledToTheEnd:
						Math.abs(categoriesContainer.scrollLeft) >=
						categoriesContainer.scrollWidth - categoriesContainer.clientWidth,
				});
			}
		}, 50);
	}

	private setGeoLocation(geoCoordinates?: IOfficesData['geoCoordinates']) {
		if (!geoCoordinates) {
			geoCoordinates = {
				latitude: 46.0515128,
				longitude: 14.5060249,
				distance: defaultDistance,
				precise: false,
			};
		}
		// TODO: office search currently gets called twice on mount, once in SearchFilter and once here, make it so it is called only once
		this.props.setLocation(geoCoordinates);
	}

	private loadMoreData() {
		this.props.searchOffices(false, false);
	}

	private toggleSpeciality(speciality: number) {
		const { setShopTypeFilter } = this.props;
		const { shopTypes } = this.props.officesData;
		const index = shopTypes.indexOf(speciality);
		const remaining = [...shopTypes];
		if (index < 0) {
			remaining.push(speciality);
		} else {
			remaining.splice(index, 1);
		}

		deleteURLSearchParams([c.SHOPS_CATEGORIES_FILTER], this.history);
		if (remaining.length > 0) {
			addURLSearchParams(c.SHOPS_CATEGORIES_FILTER, remaining.join(','), this.history);
		}
		setShopTypeFilter(remaining);
	}

	private setClicked(item: IOfficeListItem) {
		if (this.state.clicked !== item.id) {
			this.setState({
				clicked: item.id,
			});
		}
	}

	private setHovered(item: IOfficeListItem) {
		if (this.state.hoverOver !== item.id) {
			this.setState({
				hoverOver: item.id,
			});
		}
	}
	private unsetHovered() {
		this.setState({ hoverOver: undefined });
	}

	private scrollMobile(e?: React.UIEvent<HTMLDivElement>) {
		const width = document.body.clientWidth;

		// Do not trigger until map shifts to full map
		if (width > 991) {
			return;
		}

		if (e && e.target && 'scrollLeft' in e.target) {
			const target = e.target;
			if (target && (target as HTMLElement).scrollLeft) {
				const targetEl = target as HTMLElement;
				const maxScroll = targetEl.scrollWidth - targetEl.clientWidth;
				if (targetEl.scrollLeft > maxScroll - targetEl.clientWidth * 0.5 && !this.props.officesData.isFetching) {
					this.loadMoreData();
				}
			}
		}
		requestAnimationFrame(() => {
			let hoverOver: string = null;
			let biggestVisibleWidth: number = 0;
			const items = this.props.officesData.items;
			for (const item of items) {
				if (biggestVisibleWidth >= width / 2) {
					break;
				}
				const listItems = getTilesById(item.id);
				for (let i = 0; i < listItems.length; i++) {
					const rect = listItems[i].getBoundingClientRect();
					if (!rect.width || !rect.height) {
						continue;
					}
					if (rect.right <= 0 || rect.left >= width) {
						continue;
					}
					const visible = rect.left < 0 ? rect.right : width - rect.left;
					if (visible > biggestVisibleWidth) {
						biggestVisibleWidth = visible;
						hoverOver = item.id;
					}
				}
			}
			if (hoverOver && hoverOver !== this.state.hoverOver) {
				this.setState({ hoverOver });
			}
		});
	}

	private markerClick(item: IOfficeListItem) {
		this.setClicked(item);
		const listItemDesktop = getTilesByIdDesktop(item.id)[0];
		const listItemMobile = getTilesByIdMobile(item.id)[0];

		if (!listItemDesktop || !listItemMobile) {
			return;
		}
		const itemBoundingRectDesktop = listItemDesktop.getBoundingClientRect();
		const itemBoundingRectMobile = listItemMobile.getBoundingClientRect();
		const containerBounding = this.salonsItemsListRef.current.getBoundingClientRect();

		// if mobile
		if (containerBounding.height == 0) {
			listItemMobile.scrollIntoView(false);
			return;
		}

		const containerBoundingAbs = {
			top: containerBounding.top + window.scrollY,
			left: containerBounding.left + window.scrollX,
			height: containerBounding.height,
			width: containerBounding.width,
		};

		const itemBoundingRectAbs = {
			top: itemBoundingRectDesktop.top + window.scrollY - containerBoundingAbs.top - 15 /* top margin */,
			left: itemBoundingRectMobile.left + window.scrollX,
		};

		// manual scrollTo, for smooth scrolling
		const footerOffset = containerBoundingAbs.height - window.innerHeight + containerBoundingAbs.top;
		const scrollToProps: ScrollToOptions = {
			top: Math.max(0, itemBoundingRectAbs.top),
			behavior: 'smooth',
		};

		if (itemBoundingRectAbs.top > footerOffset) {
			scrollToProps.top = Math.min(itemBoundingRectAbs.top, Math.max(window.scrollY, footerOffset));
		}

		if (detectIncompatibleBrowsers()) {
			document.body.scrollTo(scrollToProps);
		} else {
			window.scrollTo(scrollToProps);
		}
	}

	private changeDistance(value: string) {
		const { geoCoordinates } = this.props.officesData;
		if (geoCoordinates) {
			const distance = Number(value) || defaultDistance;
			this.props.setLocation({
				...geoCoordinates,
				distance,
			});
		}
	}
	private resetDistance() {
		this.changeDistance('');
	}
	private resetSearch() {
		this.setState({ search: '' }, this.submitSearch);
	}
	private submitSearch(e?: React.FormEvent<HTMLFormElement>) {
		if (e) {
			e.preventDefault();
		}
	}

	private openFiltersModal() {
		this.props.showModal('SetFiltersModal', {
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
			showModal: this.props.showModal,
		});
	}

	private setBounds(bounds: google.maps.LatLngBounds) {
		this.bounds = bounds;
		if (!this.state.customBounds) {
			this.setState({ customBounds: true });
		}
	}
	private resetBounds() {
		this.bounds = undefined;
		if (this.state.customBounds) {
			this.setState({ customBounds: false });
		}
	}
	private searchArea() {
		const bounds = this.bounds;
		if (!bounds) {
			return;
		}
		this.resetBounds();
		const center = bounds.getCenter();
		const ne = bounds.getNorthEast();
		const sw = bounds.getSouthWest();
		const distance = Math.ceil(
			Math.min(
				haversine_distance(ne.lat(), ne.lng(), sw.lat(), ne.lng()),
				haversine_distance(ne.lat(), ne.lng(), ne.lat(), sw.lng()),
			) * 1000,
		);
		this.props.setLocation({
			latitude: center.lat(),
			longitude: center.lng(),
			distance,
		});
		bounds.getCenter();
	}

	public renderActiveFilters() {
		const { keywordFilter, geoCoordinates } = this.props.officesData;
		const tags: Array<{ title: string; onClick: () => void; key: string }> = [];
		if (keywordFilter) {
			tags.push({
				title: keywordFilter,
				onClick: this.resetSearch,
				key: 'keyword',
			});
		}
		if (geoCoordinates?.distance && geoCoordinates.distance !== defaultDistance) {
			const distance = geoCoordinates?.distance * 0.001;
			tags.push({
				title: distance.toFixed(distance >= 5 ? 0 : 1) + ' km',
				onClick: this.resetDistance,
				key: 'distance',
			});
		}
		if (tags.length) {
			return (
				<div className="tags">
					{tags.map((t) => (
						<div className="tag" key={t.key}>
							<span>{t.title}</span>
							<button type="button" onClick={t.onClick} className="iconBtn">
								{renderIcon('exit')}
							</button>
						</div>
					))}
				</div>
			);
		}
	}

	private handleResetAllFilters() {
		if (readURLSearchParams(c.SHOPS_CATEGORIES_FILTER)) {
			this.props.setShopTypeFilter([]);
			deleteURLSearchParams([c.SHOPS_CATEGORIES_FILTER], this.history);
		}
		if (readURLSearchParams(c.SHOPS_SEARCH_FILTER)) {
			deleteURLSearchParams([c.SHOPS_SEARCH_FILTER], this.history);
		}
		if (
			readURLSearchParams(c.SHOPS_LOCATION_FILTER) &&
			readURLSearchParams(c.SHOPS_LOCATION_FILTER_LAT) &&
			readURLSearchParams(c.SHOPS_LOCATION_FILTER_LNG)
		) {
			deleteURLSearchParams([c.SHOPS_LOCATION_FILTER, c.SHOPS_LOCATION_FILTER_LAT, c.SHOPS_LOCATION_FILTER_LNG]);
			this.props.setLocation({
				latitude: this.props.previousLatitude,
				longitude: this.props.previousLongitude,
				distance: c.SALONS_DEFAULT_MAX_DISTANCE,
			});
			this.props.setPreviousLocation(null, null);
			this.props.setLocationFilteringStatus(false);
			this.setState({ locationFilter: 0 });
		}
		if (readURLSearchParams(c.SHOPS_DATE_FILTER)) {
			deleteURLSearchParams([c.SHOPS_DATE_FILTER]);
			this.props.setDateFilter(null);
			this.setState({ dateFilter: 0 });
		}
		if (readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Min') || readURLSearchParams(c.SHOPS_HOURS_FILTER + 'Max')) {
			deleteURLSearchParams([c.SHOPS_HOURS_FILTER + 'Min', c.SHOPS_HOURS_FILTER + 'Max'], this.history);
			this.setState({ timeFilter: 0 });
		}
		if (readURLSearchParams(c.SHOPS_SORT_FILTER)) {
			deleteURLSearchParams([c.SHOPS_SORT_FILTER]);
			this.setState({ sortFilter: 0 });
		}
	}

	public render() {
		const { t, shopTypeDomainValues, userPreferences, geoLatitude, geoLongitude } = this.props;
		const { hoverOver, categoriesNotScrolled, categoriesScrolledToTheEnd } = this.state;
		const { itemsPage, isFetching, geoCoordinates, shopTypes } = this.props.officesData;

		let items = this.props.officesData.items;
		if (geoCoordinates?.precise) {
			items = items.map((i) => ({
				...i,
				origin: geoCoordinates,
			}));
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <>{t('BSPortal_Common_Loading')} </>,
		};

		const dvShopTypes = createDomainValueOptions(t, 'DV_ShopTypes_', shopTypeDomainValues, false);

		const listItems: IOfficeListItemExtended[] = items.map((i) => ({
			...i,
			className: 'officeItem-' + i.id + (hoverOver === i.id ? ' hover' : ''),
		}));

		const noSalonsResults = (
			<div className="noResultsContainer">
				<img src={require('containers/Html/images/no-results-logo.png')} alt="no results logo" />
				<div className="textContainer">
					<p className="p18">{t('BSPortal_Common_NoResultsFound')}</p>
					<p className="p14">{t('BSPortal_Common_NoResults_Subtext')}</p>
					<Button onClick={this.handleResetAllFilters}>{t('BSPortal_Common_ResetFilters')}</Button>
				</div>
			</div>
		);

		const listProps: IItemCardList<IOfficeListItemExtended> = {
			items: listItems,
			itemType: c.NODE_TYPE_OFFICE_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: noSalonsResults,
			nextPageItems,
			onMouseEnter: this.setHovered,
			onMouseLeave: this.unsetHovered,
			itemClicked: this.state.clicked,
		};

		let coordinates: google.maps.LatLngLiteral | undefined;
		if (geoCoordinates) {
			coordinates = cacheObject({
				lat: geoCoordinates.latitude,
				lng: geoCoordinates.longitude,
			});
		}

		const mapItems =
			this.state.hoverOver || this.state.clicked
				? items.map((i): AnyMapItem => {
						if (this.state.hoverOver === i.id || (this.state.clicked === i.id && !this.state.hoverOver)) {
							return {
								...i,
								isHighlighted: true,
							};
						}
						return i;
				  })
				: items;

		const iconSelector = (key: number) => {
			return 's' + key;
		};

		const handleScrollCategories = (direction: 'left' | 'right') => {
			const categoriesContainer = this.categoriesContainerRef.current;
			if (categoriesContainer && direction) {
				const pxToScrollOnClick = 240;

				if (direction === 'right') {
					categoriesContainer.scroll({ left: pxToScrollOnClick + categoriesContainer.scrollLeft, behavior: 'smooth' });
				}
				if (direction === 'left') {
					categoriesContainer.scroll({ left: categoriesContainer.scrollLeft - pxToScrollOnClick, behavior: 'smooth' });
				}
			}
		};

		const el = this.categoriesContainerRef.current;
		const checkOverflow: boolean = el && el.scrollWidth !== el.offsetWidth ? true : false;
		return (
			<div className="salonsListContainer topPadding">
				{!categoriesNotScrolled && checkOverflow ? (
					<div className="navigateWithArrowContainer left">
						<div className="opacityGradient">
							<div className="buttonHolder pointer" onClick={() => handleScrollCategories('left')}>
								{renderIcon('move_up')}
							</div>
						</div>
					</div>
				) : null}
				<div className={`tabsButtons ${checkOverflow ? 'overflowing' : ''}`} ref={this.categoriesContainerRef}>
					{dvShopTypes.map((dv) => (
						<button
							type="button"
							key={dv.key}
							className={'tab-link' + ((shopTypes || []).includes(dv.key) ? ' tab-link-active' : '')}
							onClick={() => this.toggleSpeciality(dv.key)}
						>
							{renderIcon(iconSelector(dv.key) as IconName)}
							<p className="p14">{dv.value}</p>
						</button>
					))}
				</div>
				{!categoriesScrolledToTheEnd && checkOverflow ? (
					<div className="navigateWithArrowContainer right">
						<div className="opacityGradient">
							<div className="buttonHolder pointer" onClick={() => handleScrollCategories('right')}>
								{renderIcon('move_up')}
							</div>
						</div>
					</div>
				) : null}
				<div className="search-holder">
					<SearchFilter />
					<LocationFilter />
					<DateFilter />
				</div>
				<div className="salonsList halfMap">
					<div className="itemsHolder" ref={this.salonsItemsListRef}>
						<ItemCardList {...listProps} />
					</div>
					<div className="mapHolder">
						<ItemCardList {...listProps} onScroll={this.scrollMobile} />
						<GeoMap
							showInfoWindow={true}
							items={mapItems}
							onMapMove={this.setBounds}
							onMapDrawn={this.resetBounds}
							initLocation={coordinates}
							// onMarkerMouseEnter={this.setHovered}
							// onMarkerMouseLeave={this.unsetHovered}
							onClick={this.markerClick}
							mapSettings={{ gestureHandling: 'greedy' }}
							userPicture={userPreferences.profilePicture}
							geoLatitude={geoLatitude}
							geoLongitude={geoLongitude}
							numberOfActiveFilters={
								this.state.locationFilter + this.state.dateFilter + this.state.timeFilter + this.state.sortFilter
							}
							openFiltersModal={this.openFiltersModal}
						/>
						{this.state.customBounds ? (
							<EllipseGreyBlackButton onClick={this.searchArea}>
								{t('Offices_filter_Location_Here')}
							</EllipseGreyBlackButton>
						) : null}
					</div>
				</div>
			</div>
		);
	}
}

export { SalonsPage };
